module.exports = __webpack_public_path__ + "img/playMind_share_icon.591934bd.svg";